const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionOpenSeaDragonAnnotationSelector = require('pict-section-openseadragon/source/Pict-Section-OpenSeaDragonAnnotationSelector');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationAnnotation extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsInFullScreen = false;
		this.ObservationAnnotationBackTo = 'ObservationDetails';
		this.CurrentZoomLevel = 1;
		if (!this.pict.ContentAssignment.getElement('#OSD-SVG-Sandbox')?.length)
		{
			const sandbox = document.createElement('div');
			sandbox.innerHTML = /*html*/`<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>`;
			document.body.insertBefore(sandbox, document.body.firstChild);
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.ActiveObservationDetails?.IDObservation)
		{
			this.pict.providers.ObservationProvider.getObservationByID(this.ActiveObservationDetails.IDObservation, (returnedObs) =>
			{
				if (this.ActiveObservationDetails?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image')
				{
					const tmpIDArtifact = this.ActiveObservationDetails?.Details?.Image?.[0]?.IDArtifact;
					const tmpVersion = this.ActiveObservationDetails?.Details?.Image?.[0]?.Version;
					const ImageConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragon',
						ViewAddress: 'PictSectionOpenSeaDragon',
						EnableAnnotation: true,
						PrefixUrl: './images/',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
						DrawModeLabel: 'Auto Annotate',
						TileSources:
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						},
					};
					this.ActiveObservationDetails = returnedObs;
					const existingAnnotations = this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum?.Annotations;
					if (existingAnnotations)
					{
						ImageConfiguration.Annotations = existingAnnotations;
					}

					const commentConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragonAnnotationSelector',
						ViewAddress: 'PictSectionOpenSeaDragonAnnotationSelector',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
					};
					if (!this.pict.views?.PictSectionOpenSeaDragon)
					{
						this.pict.addView('PictSectionOpenSeaDragon', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
					}
					else
					{
						this.pict.views.PictSectionOpenSeaDragon.setTileSources(
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						});
						this.pict.views.PictSectionOpenSeaDragon.setAnnotations(ImageConfiguration.Annotations || []);
					}
					if (!this.pict.views?.PictSectionOpenSeaDragonAnnotationSelector)
					{
						this.pict.addView('PictSectionOpenSeaDragonAnnotationSelector', Object.assign(libPictSectionOpenSeaDragonAnnotationSelector.default_configuration, commentConfiguration), libPictSectionOpenSeaDragonAnnotationSelector);
					}
					this.pict.views.PictSectionOpenSeaDragon.render();
					if (!this.pict.views?.OSDCommentWrapper)
					{
						const wrapperConfig =
						{
							ViewIdentifier: 'OSDCommentWrapper',
							DefaultDestinationAddress: '#ObservationComments-Container-Div',
							DefaultRenderable: 'Comment-Wrap',
							Templates: [
								{
									Hash: 'Comment-Wrap-Container',
									Template: /*html*/`
									<article id="HeadlightPanels-NavigationPanel" class="panel is-active" style="max-width: 100%; height: 100%">
										<p id="HeadlightPanels-NavigationPanel-Header" class="px-5 pt-4 pb-4 has-background-text-20" style="color: white;">
											<span class="icon has-text-text-75">
												<i class="fas fa-fw fa-comments" aria-hidden="true"></i>
											</span>
											<span>Comments</span>
										</p>
										<div class="container" style="height: calc(100% - var(--panels-navbar-height));">
											<div id="OpenSeaDragonAnnotationSelector-Container-Div" style="width:100%; height: 100%"></div>
										</div>
										<style>
											.osd-drawmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-drawmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-hatchmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-hatchmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-sandbox {
												position: fixed !important;
												z-index: 9999;
											}
											.osd-scrollable-comments {
												background-color: var(--bulma-text-70) !important;
											}
											.osd-editor-inner {
												border-radius: 6px !important;
												border: 0px !important;
											}
											.osd-comment-color-flag {
												border-bottom: 3px solid var(--bulma-text-70) !important;
												border-right: 3px solid var(--bulma-text-70) !important;
											}
											.osd-editor-inner:hover > span.osd-comment-color-flag{
												height: 14px;
												width: calc(60% + 2px);
												margin-bottom: -2px;
												margin-right: -2px;
												border-bottom: 5px solid var(--bulma-text-70) !important;
												border-right: 5px solid var(--bulma-text-70) !important;
											}
											.osd-scrollable-comments .r6o-widget.comment {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
												border-bottom: 0px !important;
											}
											.osd-scrollable-comments .r6o-widget.comment:last-child {
												border-radius: 0px 0px 6px 6px !important;
											}
											.osd-scrollable-comments .r6o-widget.r6o-tag {
												background-color: var(--bulma-warning-50) !important;
												border-radius: 0px 0px 6px 6px !important;
												border: none !important;
											}
											.osd-scrollable-comments ul.r6o-taglist > li {
												border: 1px solid var(--bulma-text-20) !important;
												background-color: transparent !important;
												border-radius: 6px !important;
												margin: 2px !important;
											}
											.osd-scrollable-comments .r6o-taglist {
												border: none !important;
											}
											.osd-scrollable-comments .r6o-editor-inner {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
											}
											.osd-scrollable-comments span.r6o-label {
												background-color: var(--bulma-text-40) !important;
												padding: 0px 6px !important;
												background-color: transparent !important;
												color: var(--bulma-text-20) !important;
												border: none !important;
												border-radius: 6px !important;
											}
											.osd-scrollable-comments .r6o-widget > .r6o-editable-text.osd-editable-text:not(:first-child) {
												border-top: 1px solid var(--bulma-text-25) !important;
											}
										</style>
									</article>`,
								},
							],
							Renderables: [
								{
									'RenderableHash': 'Comment-Wrap',
									'TemplateHash': 'Comment-Wrap-Container',
									'DestinationAddress': '#HeadlightPanels-RightPanel',
									'RenderType': 'replace',
								},
							],

						};
						this.pict.addView('OSDCommentWrapper', wrapperConfig, PictViewClass);
					}
					this.pict.views.OSDCommentWrapper.render();
					this.pict.views.PictSectionOpenSeaDragonAnnotationSelector.render();
				}
			});
		}
		this.toggleFullScreenView({ val: true });
		this.pict.views.HeadlightPanels.togglePanel('right', 'close');
		return super.onAfterRender(pRenderable);
	}

	// Saves the observation annotations.
	async saveAnnotations()
	{
		const annotationsToSave = this.pict.views?.PictSectionOpenSeaDragon?.captureAnnotations() || [];
		if (this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum)
		{
			this.ActiveObservationDetails.Details.Annotation[0].Datum.Annotations = annotationsToSave;
		}
		else if (this.ActiveObservationDetails?.Details)
		{
			this.ActiveObservationDetails.Details.Annotation = [ { Datum: { Annotations: annotationsToSave } } ];
		}

		await this.pict.providers.ObservationProvider.updateObservation(this.ActiveObservationDetails, (returnedObs)=>
		{
			this.ActiveObservationDetails = returnedObs;
			this.pict.views.HeadlightPanels.toast({
				message: 'Annotations Saved Successfully.',
				type: 'is-success',
			});
		});
	}

	async saveAndCloseAnnotation(event)
	{
		// this is kind of  a hacky workaround until we refactor panels to handle state w/ the browser routing
		await this.saveAnnotations();
		this.pict.views.HeadlightPanels.closeAllPanels();
		this.pict.fable.services.HeadlightPanels.rightPanelShow();
		this.pict.fable.services.HeadlightPanels.leftPanelShow();
		//resetting back to half the screen because annotations forces a full screen view
		this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		await this.pict.views.HeadlightPaneObservations.showObservationDetailView(event, this.ActiveObservationDetails.IDObservation, null, async () =>
		{
			// Refresh any active CardDecks so the annotation update is visible.
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.reMarshalAllViewsWithCardDecks(this.ActiveObservationDetails.IDObservation, 'AllDocumentLists', true);
			}
		}).then(() =>
		{
			// wait for transcoder to finish processing the image
			this.pict.providers.ObservationProvider.cacheBustObsImages(this.ActiveObservationDetails.IDObservation, [ 5000, 20000 ]);
		});
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open');
	}

	/**
	 * This method will set the left hand annotation panel to be as large as possible if the user toggles the mode active.
	 * @param {Object} [force] - The force object
	 * @property {boolean} force.val
	 */
	toggleFullScreenView(force)
	{
		this.ObservationDetailsInFullScreen = force ? force.val : !this.ObservationDetailsInFullScreen;
		const tmpContainer = document.querySelector('#OpenSeaDragon-Container-Div');
		if (this.ObservationDetailsInFullScreen)
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = 'calc(100vh - 65px  - 56px - 45px)';
			}
			this.fable.HeadlightPanels.leftPanelCustomWidth(100);
			this.fable.HeadlightPanels.rightPanelCustomWidth(20);
		}
		else
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = '60vh';
				tmpContainer.style.marginTop = '0';
			}
			document.querySelector('.panel-heading').classList.remove('is-hidden');
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
		}
		// make the image redraw to fit the new size every time the user toggles the full screen mode
		setTimeout(() =>
		{
			this.pict.views.ObservationAnnotation.goHome();
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationAnnotationView()
	{
		this.ActiveObservationDetails = {};
		this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		this.fable.HeadlightPanels.rightPanelResetCustomWidth();
	}

	/**
	 * @deprecated
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		() =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('PictSectionOpenSeaDragonAnnotationSelector', 'close');
			this.resetObservationAnnotationView();
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Observation Annotation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		},
		null);
	}
}

module.exports = ObservationAnnotation;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationAnnotation',
	DefaultRenderable: 'ObservationAnnotation',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationAnnotation-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationAnnotationPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationAnnotation.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="button is-small is-rounded is-pulled-right hl-panel-fullscreen-button mr-2" aria-label="fullscreen" title="Toggle full screen view" onclick="_Pict.views.ObservationAnnotation.toggleFullScreenView()">
						<span class="hl-panel-fullscreen-button">
							<i class="fas fa-fw fa-expand"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Title" class="mr-3">Observation Annotation</span>
				</p>
				<div id="HeadlightPanels-ObservationAnnotation-Content">
					{~T:ObservationAnnotation-Content:Pict.views.ObservationAnnotation.ActiveObservationDetails~}
				</div>
				<style>
					@media screen and (max-width: 900px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: column;
							height: 100px;
						}
					}
					@media screen and (min-width: 901px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: row;
							height: 50px;
						}
					}
				</style>
			</article>`,
		},
		{
			Hash: 'ObservationAnnotation-Content',
			Template: /*html*/`
			<div class="container panel-content" style="max-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<div class="columns" style="margin: 0;">
					<div style="width: 100%; position: relative;">
						<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 56px - 45px);"></div>
						<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationAnnotation-Navigation-Controls~}</div>
					</div>
					<div id="ObservationComments-Container-Div" class="" style="height: calc(100vh - 65px - 56px - 45px);"></div>
				</div>
				<button title="Done" onclick="_Pict.views.ObservationAnnotation.saveAndCloseAnnotation()" 
				style="float: right; margin: 10px;" class="button is-small is-primary"><i class="fas fa-fw fa-check-circle" style="margin-right: 5px;"></i>Done</button></div>
				<button title="Save annotation" onclick="_Pict.views.ObservationAnnotation.saveAnnotations()" style="float: right; margin: 10px;" class="button is-success is-small"><i class="fas fa-fw fa-save" style="margin-right: 5px;"></i>Save Annotations</button>
			</div>`,
		},
		{
			Hash: 'ObservationAnnotation-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Re-center image" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-arrows-to-dot"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationAnnotation',
			TemplateHash: 'ObservationAnnotation-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationAnnotation-Content',
			TemplateHash: 'ObservationAnnotation-Content',
			DestinationAddress: '#HeadlightPanels-ObservationAnnotation-Content',
			RenderType: 'replace',
		},
	],
};
